import { FC } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { useDependencies } from '@servicetitan/react-ioc';
import { Button, Flex, Menu } from '@servicetitan/anvil2';
import editIcon from '@servicetitan/anvil2/assets/icons/material/round/edit.svg';
import moreVertIcon from '@servicetitan/anvil2/assets/icons/material/round/more_vert.svg';
import doneIcon from '@servicetitan/anvil2/assets/icons/material/round/done.svg';
import closeIcon from '@servicetitan/anvil2/assets/icons/material/round/close.svg';
import { TableCellProps } from '@servicetitan/table';

import { PhoneData } from '../types/phone-data';
import { PhonesActionsCellStore } from '../stores/phones-actions-cell.store';

export const ActionsCell: FC<TableCellProps<PhoneData>> = observer(
    ({ ariaColumnIndex, colSpan, style, className, dataItem }) => {
        const [{ showDialog, handleCancel, handleEdit, handleSave }] =
            useDependencies(PhonesActionsCellStore);

        return (
            <td
                colSpan={colSpan}
                style={{ ...style }}
                className={classNames(className, 'p-1-i')}
                aria-colindex={ariaColumnIndex}
            >
                <Flex gap={2} justifyContent="center">
                    {dataItem.inEdit ? (
                        <Flex gap={2}>
                            <Button
                                appearance="primary"
                                icon={doneIcon}
                                onClick={() => handleSave(dataItem)}
                                title="Save"
                                size="small"
                            />
                            <Button
                                icon={closeIcon}
                                onClick={() => handleCancel(dataItem)}
                                title="Cancel"
                                size="small"
                            />
                        </Flex>
                    ) : (
                        <Button
                            icon={editIcon}
                            size="small"
                            aria-label="edit"
                            onClick={() => handleEdit(dataItem)}
                        />
                    )}

                    <Menu icon={moreVertIcon} size="small" aria-label="more_vert">
                        <Menu.Item
                            onClick={() => showDialog(dataItem)}
                            label="Deallocate Phone Number"
                        />
                    </Menu>
                </Flex>
            </td>
        );
    },
);
